import { PlusOutlined, VideoCameraOutlined } from '@ant-design/icons';
import { Button, Col, Pagination, Row, Spin, Typography } from 'antd';
import React from 'react';
import { DemoLibraryProps } from '../../libs/types/src';
import VideoCard from './VideoCard';

const { Title, Text } = Typography;

const DemoLibrary: React.FC<DemoLibraryProps> = ({
    demos,
    demosLoading,
    listMetaData,
    currentPage,
    pageSize,
    onCardClick,
    onPageChange,
    onUploadClick,
    onRemove,
    removeDemoLoading,
    removeDemoError,
    updateCurrentStatus,
}) => {
    return (
        <>
            <div className="demos-library-header">
                <Title level={4} className="demos-library-title">Demo Library</Title>
                <Button
                    type="primary"
                    size='middle'
                    icon={<PlusOutlined />}
                    onClick={onUploadClick}
                >
                    Upload New Demo
                </Button>
            </div>

            <Spin spinning={demosLoading} tip="Loading demos...">
                {demos && demos.length > 0 ? (
                    <Row gutter={[24, 24]} className="demos-library-row">
                        {demos.map((demo, idx) => (
                            <Col xs={24} sm={12} md={8} lg={6} key={demo.id || idx}>
                                <VideoCard
                                    id={demo.id}
                                    title={demo.file_name || demo.video_analysis?.video_metadata?.file_name || 'Untitled Demo'}
                                    attachment={demo.attachment_url}
                                    date={demo.created_at ? new Date(demo.created_at).toLocaleDateString() : 'N/A'}
                                    time={demo?.video_analysis?.video_metadata?.duration_formatted ?? 'N/A'}
                                    status={demo.status}
                                    description={demo?.video_analysis?.product_analysis?.product_description || 'No description available'}
                                    onClick={() => onCardClick(demo)}
                                    onRemove={() => onRemove(demo.id)}
                                    removeDemoLoading={removeDemoLoading}
                                    removeDemoError={removeDemoError}
                                    updateCurrentStatus={updateCurrentStatus}
                                />
                            </Col>
                        ))}
                    </Row>
                ) : (
                    !demosLoading && (
                        <div className="demos-empty-state">
                            <div className="demos-empty-icon">
                                <VideoCameraOutlined />
                            </div>
                            <Title level={4} className="demos-empty-title">No demos found</Title>
                            <Text type="secondary" className="demos-empty-text">
                                Upload your first demo video to get started with AI-powered analysis
                            </Text>
                            <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={onUploadClick}
                                className="demos-empty-action"
                            >
                                Upload Your First Demo
                            </Button>
                        </div>
                    )
                )}
            </Spin>

            {/* Pagination */}
            {listMetaData && listMetaData.count > 0 && !demosLoading && (
                <div className="demos-pagination-container">
                    <Pagination
                        current={currentPage}
                        total={listMetaData.count}
                        pageSize={pageSize}
                        showSizeChanger
                        showQuickJumper
                        showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} demos`}
                        onChange={onPageChange}
                        onShowSizeChange={onPageChange}
                        pageSizeOptions={['12', '24', '48', '96']}
                        className="demos-pagination"
                        disabled={demosLoading}
                    />
                </div>
            )}
        </>
    );
};

export default DemoLibrary; 